import { FC, Fragment, useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { format } from "date-fns";
import ReactPaginate from "react-paginate";

import RequestDateOfTreatment from "src/components/modals/requestDateOfTreatment";
import CancelTreatment from "src/components/modals/cancelTreatment";
import ConfirmIndication from "src/components/modals/confirmIndication";
import AddNote from "src/components/modals/addNote";

import { AuthContext } from "src/context/authContext";
import { ToastContext } from "src/context/toastContext";
import { LoaderContext } from "src/context/loaderContext";
import useCaseTransferFunc from "src/hooks/useCaseTransferFunc";

import { ActionDashboardActionType, ActionDashboardStateActions, ActionRequiredCompProps, TodoDataProps } from "./types";
import { ACTION_MANUFACTURE_REQUIRED, ACTION_REQUIRED } from "src/constants/todos";
import { ActionStatisticsDashboardActionType, PatientFilterStateActions } from "../manufacturer/actionDashboard/types";
import { APIEndpoints } from "src/types/apiTypes";
import useFetch from "src/hooks/useFetch";
import { ToastTypes } from "src/types";
import ReRunPatientModal from "src/components/modals/rerunPatientModal";
import UploadClinicalModal from "src/components/modals/transferCaseDialogs/uploadClinicalModal";
import TransferNotNowModal from "src/components/modals/transferCaseDialogs/transferNotNowModal";
import TransferCaseModal from "src/components/modals/transferCaseDialogs/transferCaseModal";
import { handleNavigation } from "src/helpers";
import PracticeContactInfo from "src/components/practiceContactInfo";
import TableHeader from "src/components/tableHeader";
import { ColumnSortProps } from "src/components/tableHeader/types";
import { sortTableColumns } from "src/helpers/stats";



const ActionRequired: FC<ActionRequiredCompProps> = ({ tableData, currentPage, onPageChange, onActionPerformed }): JSX.Element => {
  const [actionRequiredListing, updateActionRequiredListing] = useState<TodoDataProps[]>([]);
  const [sortingConfig, setSortingConfig] = useState<ColumnSortProps>({
    sort_by: '',
    direction: 'desc',
  });

  const [saveNoteModal, setDataforNoteModal] = useState<{ isModalVisible: boolean; caseId: number; }>({
    isModalVisible: false,
    caseId: 0,
  });
  const [showCancelIndicationModal, setDataForCancelIndication] = useState<{ isModalVisible: boolean; caseId: number; prescriptionId: number }>({
    isModalVisible: false,
    caseId: 0,
    prescriptionId: 0
  });
  const [showRequestTreatmentModal, setDataForRequestModalTreatment] = useState<{ isModalVisible: boolean; caseId: number; prescriptionId: number; bentype: string; investigated_at?: string }>({
    isModalVisible: false,
    caseId: 0,
    prescriptionId: 0,
    bentype: "",
    investigated_at: ""
  });

  const [cancelTreatmentModal, setDataForCancelModal] = useState<{ isModalVisible: boolean; caseId: number; prescriptionId: number }>({
    isModalVisible: false,
    caseId: 0,
    prescriptionId: 0
  });
   const [showReRunPatientModal, setShowReRunPatientModal] = useState<{ isModalVisible: boolean; caseId: number; prescriptionId: number,title:string,bentype:string; investigated_at?: string; }>({
    isModalVisible: false,
    caseId: 0,
    prescriptionId: 0,
    title:'',
    bentype:""
  });
   const [precertInfoModal, setPrecertInfoModal] = useState<{ isModalVisible: boolean; caseId: number; precertId: number; }>({
    isModalVisible: false,
    caseId: 0,
    precertId: 0,
  })
  const [transferCaseModal, setTransferCaseModal] = useState<{ isModalVisible: boolean; caseId: number; precertId: number; }>({
    isModalVisible: false,
    caseId: 0,
    precertId: 0,
  })
  const [transferCaseNotnowModal, setTransferCaseNotnowModal] = useState<boolean>(false)

  const navigate = useNavigate();
  const location = useLocation();
  const { isManufacturer, defaultView ,userData} = useContext(AuthContext);
  const { showToast } = useContext(ToastContext);
  const { setLoader, hideLoader } = useContext(LoaderContext);
  const { apiInPorgress: transferAPILoading, submitTransferCase } = useCaseTransferFunc({ redirectAction: onActionPerformed });
  const [pageSearch, setPageSearch] = useState(currentPage.toString());




  const { data: transferRxData, mutate: transferRxByCaseId } =
    useFetch(APIEndpoints.TRANSFER_RX);

  useEffect(() => {
    if (transferRxData) {
      hideLoader();
      const { message } = transferRxData as unknown as { code: number; message: string; };
      showToast([message], ToastTypes.SUCCESS);
      onActionPerformed();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transferRxData]);

  // useEffect(() => {
  //   if (transferRxLoading) setLoader();
  //   else hideLoader();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [transferRxLoading]);

  const ConfirmAlert = (title: string, buttonName: string, caseId: number) => {
    const result = window.confirm(title);
    if (result) {
      setLoader()
      transferRxByCaseId({}, { case_id: caseId }, { rep_xfer: true })
    }
  }

  useEffect(() => {
    updateActionRequiredListing(tableData?.todos_data ?? [])
    if (tableData?.todos_data) {
      setSortingConfig({ direction: "desc", sort_by: "" })
    }
  }, [tableData])




  const changePageNumber = (page: { selected: number }) => {
    if (isManufacturer) {
      const action: ActionStatisticsDashboardActionType = {
        type: PatientFilterStateActions.CHANGE_TODO_PAGE,
        payload: page.selected + 1,
      };
      onPageChange(action as never);
    } else {
      const action: ActionDashboardActionType = {
        type: ActionDashboardStateActions.CHANGE_TODO_PAGE,
        payload: page.selected + 1,
      };
      onPageChange(action as never);
    }
        setPageSearch((page.selected + 1).toString())

  }

  const getDateTimeFormat = (dateAndTime: string) => {
    if (dateAndTime) {
      return format(new Date(dateAndTime), "MM/dd/yyyy");
    }
  }

  // const navigateToPrecertPage = (data: any) => {
  //   const { active_precert_id, bi_case_id } = data;
  //   navigate(`/cases/${bi_case_id}/precerts/${active_precert_id}/edit`);
  // }

  // const transferCase = (msg: string, caseId: number ,transfer ?:boolean) => {
  //   // eslint-disable-next-line no-restricted-globals
  //   const res = confirm(msg);
  //   if (res) submitTransferCase(caseId,transfer)
  // }
  const transferCase = (msg: string, caseId: number ,transfer: boolean, pa_workflow_required?:boolean ,active_precert_id? : number) => {
    // eslint-disable-next-line no-restricted-globals
    // const res = confirm(msg);
    // if (res) submitTransferCase(caseId,transfer)
    //   if (pa_workflow_required) setPrecertInfoModal({ isModalVisible: true, caseId: caseId, precertId: active_precert_id || 0 })
    //  else {
    // eslint-disable-next-line no-restricted-globals
    const res = confirm(msg);
    if (res) submitTransferCase(caseId, transfer)
    // }
  }

  const navigateToModalAndPage = (item:TodoDataProps) => {
      if (item.re_run_type === 'popup'){
          setShowReRunPatientModal({ caseId: item.bi_case_id, isModalVisible: true, prescriptionId: item.prescription_id,title:"Please update case status below",bentype:"med", investigated_at: item.investigated_at ?? undefined })
      }else{
        navigate(`/cases/${item ? item.bi_case_id : 0}/clone`)
      }
    }

     const handlePageSearch = () => {
  const pageNumber = Number(pageSearch);

  if (!tableData?.page_count) return;

  if (!pageNumber || pageNumber < 1 || pageNumber > tableData.page_count) {
    // optionally reset input to current page
    setPageSearch(currentPage.toString());
    return;
  }

  // Trigger page change
  changePageNumber({ selected: pageNumber - 1 });

  // Update input to formatted value
    setPageSearch(pageNumber.toString());
};
  const redirectDecision = () => {
    const isRedirectRequired = handleNavigation(defaultView, location.pathname);
    if (isRedirectRequired) {
      navigate(defaultView.includes("/") ? defaultView : `/${defaultView}`, { replace: true })
    } else {
      navigate(0)
    }
  }

  const changeIdOrder = (value: string) => {
    sortTableColumns(value, sortingConfig, setSortingConfig, actionRequiredListing, updateActionRequiredListing)
  };

  return (
    <Fragment>
      <div className="table-responsive overflow-auto" style={{ maxHeight: "600px" }}>
        <table className="table table-striped table-sm mb-0">
          <thead className="sticky-top" style={{ zIndex: '500' }}>
            {isManufacturer === false ? <tr className="text-center align-items-center">
              {ACTION_REQUIRED.map((tableHeader, index) => (
                <TableHeader
                  key={index}
                  tableHeader={{ 
                    ...tableHeader, 
                    width: index === 7 || index === 8 ? "10%" : tableHeader.width?.toString() || "" 
                  }}
                  sortConfig={sortingConfig}
                  classNames={`${index === 7 || index === 8  ? 'border border-2 border-top-0 border-bottom-0 border-start border-dark' : ''}`}
                  changeIdOrder={changeIdOrder}
                />
              ))}
            </tr>
              :
              <tr className="text-center align-items-center">
                {ACTION_MANUFACTURE_REQUIRED.map((tableHeader, index) => (
                  (tableHeader.label === "FAM/Office Note" && userData && userData.ref_type === "rep") ?
                    <></>
                    :
                    <TableHeader
                      key={index}
                      tableHeader={{
                        ...tableHeader,
                        width: tableHeader.width?.toString() || ""
                      }}
                      classNames={`${index === 7 || index === 8 || index === 9 ? 'border border-2 border-end-0 border-top-0 border-bottom-0 border-start border-dark' : ''}`}
                      sortConfig={sortingConfig}
                      changeIdOrder={changeIdOrder}
                    />
                  )
                )}
              </tr>
            }
          </thead>

          <tbody>
            {actionRequiredListing.length > 0 ?
              actionRequiredListing.map((data, index) => {
                const isOffice = data.kam_fam_notes?.type.toLowerCase().replace(/note/g, '').trim() === "office"
                const isFam = data.kam_fam_notes?.type.toLowerCase().replace(/note/g, '').trim() === "fam"
                return (
                <tr key={index}>
                  {data.patient_name !== 'Redacted' ?
                    <td className="text-center align-middle">
                      <Link to={`/global_patients/${data.patient_id}/edit`}>
                        {data.patient_name}
                      </Link>

                    </td>
                    :
                    (
                      <td className="text-black text-center align-middle">
                        {data.patient_name}
                      </td>
                    )
                  }
                  <td className="text-center align-middle">
                    <Link to={`/global_patients/${data.patient_id}/edit`}>
                      {data.patient_id}
                    </Link>
                  </td>
                  <td className="text-center align-middle">
                    {isManufacturer ? (
                      <>
                        {data.indication.toLowerCase() === "other" ? (
                          <p className="fw-bold text-danger mb-0">{data.bi_case_id}</p>
                        ) : (
                          <Link to={`/cases/${data.bi_case_id}`} className="btn btn-link link-offset-0 link-offset-0-hover link-underline link-underline-opacity-0 link-underline-opacity-100-hover p-0 align-baseline user-select-text">
                              {data.message_icon && !isManufacturer && <i className="fas fa-comment me-1"></i>}{data.bi_case_id}
                          </Link>
                        )}
                      </>
                    ) : (
                      <Link to={`/cases/${data.bi_case_id}`} className="btn btn-link link-offset-0 link-offset-0-hover link-underline link-underline-opacity-0 link-underline-opacity-100-hover p-0 align-baseline user-select-text">
                          {data.message_icon && !isManufacturer && <i className="fas fa-comment me-1"></i>}{data.bi_case_id}
                      </Link>
                    )}
                  </td>

                  <td className="text-center align-middle">
                    {typeof data.reverification === "string" && data.reverification ? (
                      <button type="button" className={`btn btn-sm ${data.reverification.toLowerCase() === "new" ? "background-color-2 text-white fw-bold btn-new" : "btn-green btn-new"}`}>
                        {data.reverification}
                      </button>
                    ) : null}
                  </td>
                  <td className="text-center align-middle">
                    {isManufacturer ? getDateTimeFormat(data.bi_completed) : data.bi_completed}
                  </td>
                  <td className="text-center align-middle">
                    {isManufacturer === false ? data.insurance_type : data.payer}
                  </td>
                  <td className="text-center align-middle">
                    <PracticeContactInfo
                      name={data.practice_name} 
                      address={data.practice_full_address} 
                      phone={data.practice_phone_number ?? ""}
                      fax={data.practice_fax_number ?? ""}
                      indexKey={index}
                    >
                      <>{data.physician}</>
                    </PracticeContactInfo>
                  </td>
                  <td 
                    className={`text-center text-light align-middle fw-bold status-borders background-color-${data.medical_coverage_status_color}`}
                    title={data.medical_coverage_tooltip}
                    data-bs-toggle="tooltip"
                  >
                    {data.medical_coverage_status}
                  </td>

                  <td 
                    className={`text-center text-light align-middle fw-bold status-borders background-color-${data.pharmacy_coverage_status_color}`}
                    title={data.pharmacy_coverage_tooltip}
                    data-bs-toggle="tooltip"
                  >
                    {data.pharmacy_coverage_status}
                  </td>
                  {isManufacturer ?
                    (<td className={`text-center text-light align-middle`} id="next-steps">
                      {data.indication.toLowerCase() === "other" ? 
                        <span className="text-black">No Action Available</span> : null}
                      {data && data.indication.toLowerCase() !== "other" && data['next_steps'].map((step, index) => {
                        // {data?.medical_next_steps?.map((step, index) => {
                        if (step === "Treated") {
                          return (
                            <button
                              key={index}
                              className="btn btn-green btn-sm rounded-0 m-1"
                              onClick={() =>
                                setDataForRequestModalTreatment( {
                                  isModalVisible: true,
                                  caseId: data.bi_case_id,
                                  prescriptionId: data.prescription_id,
                                  bentype: "med",
                                  investigated_at: data.investigated_at || "",
                                } )
                              }
                              type="button"
                            >
                              <i className="far fa-clipboard"></i> Treated
                            </button>
                          );
                        } else if ( step === "Not Treating" ) {
                          return (
                            <button
                              key={index}
                              className="btn btn-green btn-sm rounded-0 m-1"
                              onClick={() =>
                                setDataForCancelModal( {
                                  isModalVisible: true,
                                  caseId: data.bi_case_id,
                                  prescriptionId: data.prescription_id,
                                } )
                              }
                              type="button"
                            >
                              <i className="fas fa-times"></i> Not Treated
                            </button>
                          );
                        } else if ( step === "Not Treated" ) {
                          return (
                            <button
                              key={index}
                              className="btn btn-green btn-sm rounded-0 m-1"
                              onClick={() =>
                                setDataForCancelModal( {
                                  isModalVisible: true,
                                  caseId: data.bi_case_id,
                                  prescriptionId: data.prescription_id,
                                } )
                              }
                              type="button"
                            >
                              <i className="fas fa-times"></i> Not Treated
                            </button>
                          );
                        } else if ( step === "Transferred" ) {
                          return (
                            <button
                              key={index}
                              className="btn btn-green btn-sm rounded-0 m-1"
                              onClick={() =>
                                ConfirmAlert(
                                  "By clicking this you are noting the office has tranferred this prescription to a Specialty Pharmacy. Are you sure you want to mark this prescription transferred? This cannot be undone!",
                                  "xFerToSP",
                                  data.bi_case_id
                                )
                              }
                              type="button"
                            >
                              <i className="fas fa-times"></i> Transferred
                            </button>
                          );
                        } else if ( step === "Treatment Scheduled" ) {
                          return (
                            <button
                              key={index}
                              className="btn btn-green btn-sm background-color-3 rounded-0 m-1"
                              onClick={() =>
                                setDataForRequestModalTreatment( {
                                  isModalVisible: true,
                                  caseId: data.bi_case_id,
                                  prescriptionId: data.prescription_id,
                                  bentype: "sd",
                                } )
                              }
                              type="button"
                            >
                              <i className="fas fa-times"></i> Treatment Scheduled
                            </button>
                          );
                        } else if (step.includes("Scheduled Tx Date")) {
                            return (
                              <button key={index} className="btn btn-link btn-sm m-1 user-select-text"
                                onClick={() => setDataForRequestModalTreatment({ isModalVisible: true, caseId: data.bi_case_id, prescriptionId: data.prescription_id, bentype: "sd" })}
                                type="button">
                                {step}
                              </button>
                            );
                        }  else {
                          return <p className="text-black">No Action Available</p>;
                        }

                      })
                      }

                    </td>)
                    :
                    (
                      <td className={`text-center text-light align-middle`} id="next-steps">
                        {data && data['next_steps']?.map((step, index) => {
                          //{data && data['next_steps'].map((step, index) => {

                          // switch (step) {
                          //not coming
                          if (step === "Treated") {
                            return (
                              <button key={index} className="btn btn-green btn-sm rounded-0 m-1" type="button"
                                onClick={() => setDataForRequestModalTreatment({ isModalVisible: true, caseId: data.bi_case_id, prescriptionId: data.prescription_id, bentype: "na", investigated_at: data.investigated_at || "" })}
                              >
                                <i className="far fa-clipboard"></i> Treated
                              </button>
                            );
                          }

                          else if (step === "Treatment Scheduled") {
                            return (
                              <button key={index} className="btn btn-green btn-sm background-color-3 rounded-0 m-1"
                                onClick={() => setDataForRequestModalTreatment({ isModalVisible: true, caseId: data.bi_case_id, prescriptionId: data.prescription_id, bentype: "sd" })}
                                //onClick={()=>navigateToPrecertPage(data)}

                                type="button">

                                <i className="fa fa-times"></i> Treatment Scheduled
                              </button>
                            );
                          }
                          //not coming
                          else if (step === "Schedule") {
                            return (
                              <button key={index} className="btn btn-green btn-sm background-color-3 rounded-0 m-1"
                                onClick={() => setDataForRequestModalTreatment({ isModalVisible: true, caseId: data.bi_case_id, prescriptionId: data.prescription_id, bentype: "non" })}
                                type="button">

                                <i className="bi bi-x-lg"></i> Schedule
                              </button>
                            );
                          }
                          //not coming
                          else if (step === "Not Treating") {
                            return (
                              <button key={index} onClick={() => setDataForCancelModal({ caseId: data.bi_case_id, isModalVisible: true, prescriptionId: data?.prescription_id })} className="btn btn-green btn-sm rounded-0 m-1" type="button">
                                <i className="fa fa-times"></i> Not Treating
                              </button>
                            );
                          }

                          else if (step === "Precert") {
                            return <></>
                            // return (
                            //     <div>
                            //         <button
                            //             key={index}
                            //             className="btn btn-sm background-color-5 my-1 text-white"
                            //             type="button"
                            //             onClick={() => showToast(["Precert not found!"], ToastTypes.ERROR)}
                            //         >
                            //             <i className="fas fa-clipboard-list"></i> Precert
                            //         </button>
                            //     </div>
                            // );

                          } 
                          // else if (step === "Review") {
                          //   return (
                          //     <button
                          //       key={index}
                          //       className="btn background-color-2 btn-sm rounded-0 m-1 text-white"
                          //       type="button"
                          //       onClick={() => navigate(`/cases/${data.bi_case_id}/precerts/${data.pending_precert_id}/review`)}
                          //     >
                          //       <i className="fas fa-clipboard-list"></i> Review
                          //     </button>
                          //   );

                          // } else if (step === "Appeal") {
                          //   return (
                          //     <button
                          //       key={index}
                          //       className="btn btn-green background-color-3 rounded-0 m-1"
                          //       type="button"
                          //       onClick={() => submiAppealForCase(data.bi_case_id, data.appeal_precert_id || 0)}
                          //       disabled={apiInPorgress}
                          //     >
                          //       <i className="far fa-clipboard"></i> Appeal
                          //     </button>
                          //   );

                          // } 
                          else if (step === "Transfer to Alliance Rx Walgreens") {
                            return (
                              <button
                                key={index}
                                className="btn btn-green btn-sm background-color-2 rounded-0 m-1"
                                type="button"
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                title="Clicking this button will transfer the prescription through the Specialty Pharmacy Channel"
                                onClick={() => 
                                  transferCase(
                                    "Are you sure you want to transfer this prescription? This cannot be undone!",
                                    data.bi_case_id, true, data.pa_workflow_required, data.active_precert_id
                                  )
                                }
                                disabled={transferAPILoading}
                              >
                                <i className="fas fa-prescription"></i> Transfer to Alliance Rx Walgreens
                              </button>
                            );

                          } 
                          //not coming
                          else if (step === "Transferred to other Specialty Pharmacy") {
                            return (
                                <div>
                                    <button
                                        key={index}
                                        className="btn btn-green btn-sm background-color-2 rounded-0 m-1 text-nowrap"
                                        type="button"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Clicking this button indicates your office has already transferred this case to a local pharmacy"
                                        onClick={() => 
                                          transferCase(
                                            "ALERT: Clicking this button indicates your office has already transferred this case to a local pharmacy outside of MQC. Your office will be responsible for any PA requirements as well as follow up with that pharmacy",
                                            data.bi_case_id, true
                                          )
                                        }
                                        disabled={transferAPILoading}
                                    >
                                        <i className="fas fa-prescription"></i> Transferred to other Specialty Pharmacy
                                    </button>
                                </div>
                            );

                          } 
                          //not coming
                          else if (step === "Transfer to CenterWell") {
                            return (
                                <div>
                                    <button
                                        key={index}
                                        className="btn btn-green btn-sm background-color-2 rounded-0 m-1"
                                        type="button"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Clicking this button will transfer the prescription through the Specialty Pharmacy Channel"
                                        onClick={() => {
                                          if (data.pa_workflow_required) {
                                            setTransferCaseModal({ isModalVisible: true, caseId: data.bi_case_id, precertId: 0 })
                                          } else {
                                            transferCase(
                                              "Are you sure you want to transfer this prescription? This cannot be undone!",
                                              data.bi_case_id, true, data.pa_workflow_required, data.active_precert_id
                                            )
                                          }
                                        }}
                                        disabled={transferAPILoading}
                                    >
                                        <i className="fas fa-prescription"></i> Transfer to CenterWell
                                    </button>
                                </div>
                            );

                          } 
                          //not coming
                          else if (step === "Transfer to Knipper") {
                            return (
                              <button
                                key={index}
                                className="btn btn-green btn-sm background-color-2 rounded-0 m-1"
                                type="button"
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                title="Clicking this button will transfer the prescription through the Specialty Pharmacy Channel"
                                onClick={() =>
                                  transferCase(
                                    "Are you sure you want to transfer this prescription? This cannot be undone!",
                                    data.bi_case_id, true, data.pa_workflow_required, data.active_precert_id
                                  )
                                }
                                disabled={transferAPILoading}
                              >
                                <i className="fas fa-prescription"></i> Transfer to Knipper
                              </button>
                            );

                          } 
                          // else if (step === "No Action Required") {
                          //   return (
                          //     <p className="text-black">No Action Required</p>
                          //   );

                          // }
                          else if (step.includes("Scheduled Tx Date")) {
                            return (
                              <button key={index} className="btn btn-link btn-sm m-1 user-select-text"
                                onClick={() => setDataForRequestModalTreatment({ isModalVisible: true, caseId: data.bi_case_id, prescriptionId: data.prescription_id, bentype: "sd" })}
                                type="button">
                                {step}
                              </button>
                            );

                          } 
                          //not coming
                          // else if (step.match(/\d{2}\/\d{2}\/\d{4}/)) {
                          //   return (
                          //     <button key={index} className="btn btn-link m-1"
                          //       onClick={() => setDataForRequestModalTreatment({ isModalVisible: true, caseId: data.bi_case_id, prescriptionId: data.prescription_id, bentype: "non" })}
                          //       type="button"
                          //     >
                          //       {step}
                          //     </button>
                          //   );
                          // }

                          else if (["review", "appeal"].includes(step.toLowerCase())) {
                            return (<></>);
                          } else {
                            return (<span key={index} className="text-black">{step}</span>);
                          }
                        }
                        )
                        }
                      </td>
                    )
                  }
                  {isManufacturer &&
                      <>
                        <td className="align-middle text-center">
                         {data.pcc}
                       </td>
                       <td className="align-middle text-center">
                         {data.qns}
                       </td>
                        <td className="align-middle text-center">
                          {data.patient_actv_status}
                        </td>
                      </>
                  }
                 {!isManufacturer &&
                     <> <td className="align-middle text-center">
                        <span className="btn btn-green text-nowrap rounded-0" onClick={() => navigateToModalAndPage(data)}>
                          <i className="fas fa-sync-alt"></i> Re-run
                        </span>
                      </td>
                      <td className="align-middle text-center fs-6" style={{ minWidth: '105px' }}>
                        {data.kam_fam_notes?.clickable && data.kam_fam_notes.text ? (
                          data.kam_fam_notes.text === 'Add Note' ? (
                            <button
                              type="button"
                              className="btn btn-green btn-sm rounded-0"
                              onClick={() =>
                                setDataforNoteModal({ isModalVisible: true, caseId: data.bi_case_id })
                              }
                            >
                              <i className="fas fa-times me-1"></i>
                              {data.kam_fam_notes.text}
                            </button>
                          ) : data.kam_fam_notes.text === 'Confirm Indication' ? (
                            <button
                              type="button"
                              className="btn btn-green btn-sm rounded-0"
                              onClick={() =>
                                setDataforNoteModal({ isModalVisible: true, caseId: data.bi_case_id })
                              }
                            >
                              <i className="fas fa-times me-1"></i>
                              {"Add Note"}
                            </button>
                          ) : (
                            (isManufacturer || !String(data.kam_fam_notes?.text).includes("No FAM Action Needed"))
                              ? (
                                <button
                                  className={`btn btn-link ${isOffice ? "btn-office" : isFam ? "btn-fam" : ""} user-select-text`}
                                  onClick={() =>
                                    setDataforNoteModal({
                                      isModalVisible: true,
                                      caseId: data.bi_case_id
                                    })
                                  }
                                >
                                  {(data.kam_fam_notes?.text as string).replace("No FAM Action Needed", "")}
                                  {/* {data.kam_fam_notes?.text} */}
                                </button>
                              ) : (
                                <button
                                  type="button"
                                  className="btn btn-green btn-sm rounded-0"
                                  onClick={() =>
                                    setDataforNoteModal({
                                      isModalVisible: true,
                                      caseId: data.bi_case_id
                                    })
                                  }
                                >
                                  <i className="fas fa-times me-1"></i> Add Note
                                </button>
                              )
                          )
                        ) : (
                          // 'N/A'
                          <button
                              type="button"
                              className="btn btn-green btn-sm rounded-0"
                              onClick={() =>
                                setDataforNoteModal({ isModalVisible: true, caseId: data.bi_case_id })
                              }
                            >
                              <i className="fas fa-times me-1"></i>
                              {"Add Note"}
                            </button>
                        )}
                      </td>
                      </>
                    }

                  {isManufacturer && (
                    <>
                      <td className="text-center align-middle fs-6">
                        {data.indication ? data.indication : 'N/A'}
                      </td>
                      {/* <td className="text-center align-middle fs-6">
                        {data.confirm_indication.clickable ?
                          <button
                            type="button" className="btn btn-success btn-sm rounded-0"
                            onClick={() => setDataForCancelIndication({ isModalVisible: true, caseId: data.bi_case_id, prescriptionId: data.prescription_id })}
                          >
                            Confirm Indication
                          </button>
                          : <p>{data.confirm_indication.text || "N/A"}</p>
                        }
                      </td> */}
                     { userData?.ref_type !== "rep" &&
                     <td className="align-middle text-center fs-6" style={{ minWidth: '105px' }}>
                        {data.kam_fam_notes?.clickable && data.kam_fam_notes.text ? (
                          data.kam_fam_notes.text === 'Add Note' ? (
                            <button
                              type="button"
                              className="btn btn-green btn-sm rounded-0"
                              onClick={() =>
                                setDataforNoteModal({ isModalVisible: true, caseId: data.bi_case_id })
                              }
                            >
                              <i className="fas fa-times me-1"></i>
                              {data.kam_fam_notes.text}
                            </button>
                          ) : data.kam_fam_notes.text === 'Confirm Indication' ? (
                            <></>
                          ) : 
                          // (!(String(data?.kam_fam_notes?.text ?? "").includes("No FAM Action Needed")) && !isManufacturer) ? (
                          //   <button
                          //     className={`btn btn-link ${isOffice ? "btn-office" : isFam ? "btn-fam" : ""}`}
                          //     onClick={() =>
                          //       setDataforNoteModal({ isModalVisible: true, caseId: data.bi_case_id })
                          //     }
                          //   >
                          //     {data.kam_fam_notes.text}
                          //   </button>
                          // ):(<button
                          //   type="button"
                          //   className="btn btn-green btn-sm rounded-0"
                          //   onClick={() =>
                          //     setDataforNoteModal({ isModalVisible: true, caseId: data.bi_case_id })
                          //   }
                          // >
                          //   <i className="fas fa-times me-1"></i> Add Note
                          // </button>)
                          (isManufacturer || !String(data.kam_fam_notes?.text).includes("No FAM Action Needed"))
                                  ? (
                                    <button
                                      className={`btn btn-link ${isOffice ? "btn-office" : isFam ? "btn-fam" : ""} user-select-text`}
                                      onClick={() =>
                                        setDataforNoteModal({
                                          isModalVisible: true,
                                          caseId: data.bi_case_id
                                        })
                                      }
                                    >
                                      {data.kam_fam_notes?.text}
                                    </button>
                                  ) : (
                                    <button
                                      type="button"
                                      className="btn btn-green btn-sm rounded-0"
                                      onClick={() =>
                                        setDataforNoteModal({
                                          isModalVisible: true,
                                          caseId: data.bi_case_id
                                        })
                                      }
                                    >
                                      <i className="fas fa-times me-1"></i> Add Note
                                    </button>
                                  )
                        ) : (
                          'N/A'
                        )}
                      </td>}
                    </>
                  )}
                </tr>
                )
              })
              : null}
          </tbody>
        </table>
      </div>

      {isManufacturer && (tableData && tableData.page_count && tableData.page_count > 1 ? (
        <div className="flex-wrap justify-content-center mt-3 pagination pagination-lg pagination-sm">
          {currentPage !== 1 ? (
            <li className="page-data">
              <button className="btn btn-link page-link rounded-0" onClick={() => changePageNumber({ selected: 0 })}>
                <i className="bi bi-chevron-double-left"></i> First
              </button>
            </li>
          ) : null}

          <ReactPaginate
            nextLabel={<>Next <i className="bi bi-chevron-right"></i></>}
            onPageChange={changePageNumber}
            pageRangeDisplayed={3}
            marginPagesDisplayed={2}
            pageCount={tableData.page_count}
            previousLabel={<><i className="bi bi-chevron-left"></i> Previous</>}
            pageClassName="page-data"
            pageLinkClassName="page-link"
            previousClassName="page-data"
            previousLinkClassName="page-link rounded-0"
            nextClassName="page-data"
            nextLinkClassName="page-link rounded-0"
            breakLabel="..."
            breakClassName="page-data"
            breakLinkClassName="page-link"
            containerClassName="pagination pagination-sm pagination-lg"
            activeClassName="active"
            renderOnZeroPageCount={null}
            forcePage={currentPage - 1}
          />

          {currentPage !== tableData.page_count ? (
            <li className={`page-data ${currentPage === tableData.page_count ? 'disabled' : ''}`}>
              <button className="btn btn-link page-link rounded-0" onClick={() => changePageNumber({ selected: tableData.page_count - 1 })}>
                Last <i className="bi bi-chevron-double-right"></i>
              </button>
            </li>
          ) : null}
           <li className="page-item">
              <input
                type="number"
                min={1}
                max={tableData.page_count}
                className="form-control page-link"
                style={{ width: "67px" }}
                placeholder="Page"
                value={pageSearch}
                onChange={(e) => setPageSearch(e.target.value)}
                onBlur={handlePageSearch}          // 👈 Fire on focus out
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.currentTarget.blur();        // 👈 Trigger blur = auto jump
                  }
                }}
              />
            </li>
        </div>
      ) : null)}
      <ConfirmIndication
        isModalVisible={showCancelIndicationModal.isModalVisible}
        caseId={showCancelIndicationModal.caseId}
        prescriptionId={showCancelIndicationModal.prescriptionId}
        hideModal={() => {
          setDataForCancelIndication({
            isModalVisible: false,
            caseId: 0,
            prescriptionId: 0
          });
        }}
        refreshListing={() => redirectDecision()}
      />

      {saveNoteModal.isModalVisible ? (
        <AddNote
          isModalVisible={saveNoteModal.isModalVisible}
          caseId={saveNoteModal.caseId}
          refreshListing={() => isManufacturer ? onActionPerformed() : redirectDecision()}
          hideModal={() => {
            setDataforNoteModal({
              isModalVisible: false,
              caseId: 0,
            });
          }}
        />
      ) : null}

      {showRequestTreatmentModal.isModalVisible && (
        <RequestDateOfTreatment
          isModalVisible={showRequestTreatmentModal.isModalVisible}
          caseId={showRequestTreatmentModal.caseId}
          prescriptionId={showRequestTreatmentModal.prescriptionId}
          bentype={showRequestTreatmentModal.bentype}
          investigated_at={showRequestTreatmentModal.investigated_at}
          hideModal={() => {
            setDataForRequestModalTreatment({
              isModalVisible: false,
              caseId: 0,
              prescriptionId: 0,
              bentype: '',
              investigated_at: ""
            });
          }}
          refreshListing={() => redirectDecision()}
        />
      )}

      <CancelTreatment
        isModalVisible={cancelTreatmentModal.isModalVisible}
        caseId={cancelTreatmentModal.caseId}
        prescriptionId={cancelTreatmentModal.prescriptionId}
        hideModal={() => {
          setDataForCancelModal({
            isModalVisible: false,
            caseId: 0,
            prescriptionId: 0
          });
        }}
        refreshListing={() => redirectDecision()}
      />
        <ReRunPatientModal
          isModalVisible={showReRunPatientModal.isModalVisible}
          caseId={showReRunPatientModal.caseId}
          prescriptionId={showReRunPatientModal.prescriptionId}
          bentype={showReRunPatientModal.bentype}
          title={showReRunPatientModal.title}
          investigated_at={showReRunPatientModal.investigated_at}
          hideModal={() => {
            setShowReRunPatientModal({
              isModalVisible: false,
              caseId: 0,
              prescriptionId: 0,
              bentype: '',
              title:"",
              investigated_at: undefined
            });
          }}
          refreshListing={() => redirectDecision()}
        />
      <UploadClinicalModal
        caseId={precertInfoModal.caseId}
        precertId={precertInfoModal.precertId}
        isModalVisible={precertInfoModal.isModalVisible}
        hideModal={(shouldFetchAgain: boolean) => {
          if (shouldFetchAgain) {
            redirectDecision();
            const action: ActionStatisticsDashboardActionType = {
              type: PatientFilterStateActions.CHANGE_TREATABLE_PAGE,
              payload: currentPage,
            };
            onPageChange(action as never)
          }
          setPrecertInfoModal({
            isModalVisible: false,
            caseId: 0,
            precertId: 0,
          })
        }}
      />
      <TransferCaseModal
        isModalVisible={transferCaseModal.isModalVisible}
        hideModal={() => {
          setTransferCaseModal({
            caseId: 0,
            precertId: 0,
            isModalVisible: false,
          })
          setTransferCaseNotnowModal(true)
        }}
        uploadClinicalInfo={() => {
          setPrecertInfoModal({
            isModalVisible: true,
            caseId: transferCaseModal.caseId,
            precertId: transferCaseModal.precertId,
          })
          setTransferCaseModal({
            caseId: 0,
            precertId: 0,
            isModalVisible: false,
          })
        }}
      />

      <TransferNotNowModal
        isModalVisible={transferCaseNotnowModal}
        hideModal={() => setTransferCaseNotnowModal(false)}
      />
    </Fragment>
  );
};

export default ActionRequired;
